import { render } from "./AssignAdultForm.vue?vue&type=template&id=374a7335"
import script from "./AssignAdultForm.vue?vue&type=script&lang=js"
export * from "./AssignAdultForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__